import Vue from 'vue'
import VueCookies from 'vue-cookies';
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

Vue.use(VueCookies)
Vue.use(Vuex)

const cart = new Vuex.Store({
  state: {
    quantity: 0
  },

  plugins: [
    createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    })
  ],

  mutations: {
    setQuantity(state, quantity) {
      state.quantity = (quantity == 0) ? '0' : quantity;
    }
  },

  actions: {
    getCartQuantity({ commit }) {
      const headers = {
        'x-key': VueCookies.get("key")
      }

      axios.get(process.env.DINO.PATH.GET_CART_QUANTITY, { headers: headers })
      .then(response => {
        commit('setQuantity', response.data.quantity);
        if (response.data.key_created) {
          VueCookies.set("key", response.headers['x-key'], '3d');
        }
      })
      .catch(err => {
      });
    }
  },

  getters: {
    quantity(state) {
      return state.quantity;
    }
  }
});


export default cart;



// WEBPACK FOOTER //
// ./src/stores/Cart.js